var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCorreo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    fill: "#285171"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 31.6666C10.6001 31.6666 9.97253 31.4057 9.45075 30.8839C8.92897 30.3621 8.66764 29.7341 8.66675 28.9999V12.9999C8.66675 12.2666 8.92808 11.639 9.45075 11.1173C9.97341 10.5955 10.601 10.3341 11.3334 10.3333H32.6667C33.4001 10.3333 34.0281 10.5946 34.5507 11.1173C35.0734 11.6399 35.3343 12.2675 35.3334 12.9999V28.9999C35.3334 29.7333 35.0725 30.3613 34.5507 30.8839C34.029 31.4066 33.401 31.6675 32.6667 31.6666H11.3334ZM22.0001 22.3333L11.3334 15.6666V28.9999H32.6667V15.6666L22.0001 22.3333ZM22.0001 19.6666L32.6667 12.9999H11.3334L22.0001 19.6666ZM11.3334 15.6666V12.9999V28.9999V15.6666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCorreo);
export default __webpack_public_path__ + "static/media/ic_correo.25b6643354b77bdcc252c689a16166a8.svg";
export { ForwardRef as ReactComponent };